import * as React from 'react';
import { useState, useEffect } from 'react';
import { auth } from "../../../contexts/authentication";
import fetchInstances from "../../utils/instances/fetchInstances";
import type { } from '@mui/x-date-pickers/themeAugmentation';
import type { } from '@mui/x-charts/themeAugmentation';
import type { } from '@mui/x-data-grid-pro/themeAugmentation';
import type { } from '@mui/x-tree-view/themeAugmentation';
import { alpha } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import AppNavbar from '../../components/AppNavbar';
import Header from '../../components/Header';
import SideMenu from '../../components/SideMenu';
import AppTheme from '../../shared-theme/AppTheme';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { Card } from '@mui/material';
import Pricing from '../../components/Pricing';
import Instance from './instance/Instance';
import Settings from './settings/Settings';
import Typebot from './typebot/Typebot';

export default function WhatsappSettings(props: { disableCustomTheme?: boolean }) {
  const [value, setValue] = useState('1');
  const [instance, setInstance] = useState<string | null>(null);
  const [loadingPage, setLoadingPage] = useState(true);
  const [hideTabs, setHideTabs] = useState(true);
  const currentUser = auth.currentUser;
  const uid = currentUser?.uid;

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  useEffect(() => {
    const getInstance = async () => {
      const data = await fetchInstances();
      const index = data.find((item: { name: string }) => item.name === uid);
      setInstance(index?.id);
    };
    getInstance();
  }, []);

  setTimeout(() => {
    setLoadingPage(false);
  }, 2000);

  return (
    <AppTheme {...props}>
      <CssBaseline enableColorScheme />
      <Box sx={{ display: 'flex' }}>
        <SideMenu />
        <AppNavbar />
        <Box
          component="main"
          sx={(theme: any) => ({
            flexGrow: 1,
            backgroundColor: theme.vars
              ? `rgba(${theme.vars.palette.background.defaultChannel} / 1)`
              : alpha(theme.palette.background.default, 1),
            overflow: 'auto',
          })}
        >
          <Stack
            spacing={2}
            sx={{
              alignItems: 'center',
              mx: 3,
              pb: 5,
              mt: { xs: 8, md: 0 },
            }}
          >
            <Header />
            <Box sx={{ width: '100%' }}>
              <Card>
                <TabContext value={value}>
                  <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <TabList onChange={handleChange} aria-label="lab API tabs example">
                      <Tab label="Instância" value="1" sx={{ fontSize: '0.8rem' }} />
                      {!hideTabs && <Tab label="Comportamento" value="2" sx={{ fontSize: '0.8rem' }} />}
                      {!hideTabs && <Tab label="Assistente" value="3" sx={{ fontSize: '0.8rem' }} />}
                    </TabList>
                  </Box>
                  <TabPanel value="1">
                    <Instance
                      setHideTabs={setHideTabs}
                    />
                  </TabPanel>
                  <TabPanel value="2" sx={{ p: 0 }}>
                    <Settings />
                  </TabPanel>
                  <TabPanel value="3" sx={{ p: 0 }}>
                    <Typebot />
                  </TabPanel>
                </TabContext>
              </Card>
            </Box>
          </Stack>
        </Box>
      </Box>
    </AppTheme>
  );
}